import React from "react";
import "./GenericComponentsStyle.css";

const RequiredAsteriskComponent = () => {
  return <span className="required-asterisk">*</span>;
};
export default RequiredAsteriskComponent;
